import { Breadcrumb, Button, Card, Col, Dropdown, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";
import TableAntd from "components/elements/Table";
import { DownloadOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import EmployeePayrollModal from "../reportModal/EmployeePayrollModal";
import dayjs from 'dayjs';

function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format(reFormat);
}

const EmployeePayrollReportComponent = ({
    showReport,
    pagination,
    isModalOpen = false,
    positionOptions = [],
    departmentOptions = [],
    employeeStatusTypeOptions = [],
    employmentTypeOptions = [],
    reportEmployeeEarningTable = [],
    setIsModalOpen = () => { },
    handleSearch = () => { },
    showModal = () => { },
    onChange = () => { },
    updatePeriodOptions = () => { },
    periodOptions = [],
    setYear = () => { },
    setMonth = () => { },
    exportEmployeeEarningRecordReportExcel = () => { },
    exportEmployeeEarningRecordReportExcelPlus = () => { },
    exportEmployeeEarningRecordReportPdf = () => { },
    previewEmployeeEarningReport = () => { },
    exportEmployeeEarningRecordReportPdfByEmp = () => { },
    isExcelLoading = false,
    isExcelLoading2 = false,
    isPDFLoading = false,
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 180,
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (record?.name ?
                    (i18n.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (
                    record?.department?.id ? (i18n.language === "en" ? record?.department?.organizationNameEn : record?.department?.organizationName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 300,
            render: (_, record) => {
                return (
                    record?.position?.id ? (i18n.language === "en" ? record?.position?.positionNameEn : record?.position?.positionName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('employment-type')}</div>,
            dataIndex: "employmentType",
            key: "employmentType",
            width: 200,
            align: "left",
            render: (_, record) => {
                return (
                    record?.employmentType?.employmentTypeId ? (i18n.language === "en" ? record?.employmentType?.nameEn : record?.employmentType?.name) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('report.payroll_period')}</div>,
            dataIndex: "payrollPeriod",
            key: "payrollPeriod",
            width: 250,
            align: "center",
            render: (_, record) => {
                return (
                    formatDate({ dateString: record?.startPeriodDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) + " - " + formatDate({ dateString: record?.endPeriodDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })
                )
            },
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        placement="bottomRight"
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => previewEmployeeEarningReport(record)}
                                        >
                                            {t("action.view_more")}
                                        </p>
                                    ),
                                    icon: (
                                        <EyeOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => previewEmployeeEarningReport(record)}
                                        />
                                    ),
                                },
                                {
                                    key: "2",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => exportEmployeeEarningRecordReportPdfByEmp(record)}
                                        >
                                            {t("action.download")}
                                        </p>
                                    ),
                                    icon: (
                                        <DownloadOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => exportEmployeeEarningRecordReportPdfByEmp(record)}
                                        />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
    ]

    return (
        <MainLayout>
            <EmployeePayrollModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportEmployeeEarningRecordReportExcel={exportEmployeeEarningRecordReportExcel}
                exportEmployeeEarningRecordReportExcelPlus={exportEmployeeEarningRecordReportExcelPlus}
                exportEmployeeEarningRecordReportPdf={exportEmployeeEarningRecordReportPdf}
                isExcelLoading={isExcelLoading}
                isExcelLoading2={isExcelLoading2}
                isPDFLoading={isPDFLoading}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("salary_calculation_group.header"), href: "" },
                        { title: t("employee_payroll_report.header") }
                    ]} />
                    <h2>{t("employee_payroll_report.header")}</h2>
                </Flex>

                <FormAntd
                    onFinish={handleSearch}
                    initialValues={{ year: dayjs() }}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employmentTypeId"
                                                        label={t("salary.label.employment_type")}
                                                        size="large"
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        options={employmentTypeOptions}
                                                        mode="multiple"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employeeStatusId"
                                                        label={t('employee.label.employee_status')}
                                                        options={employeeStatusTypeOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        mode="multiple"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('payroll_period.label.tax_year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        required
                                                        onChange={(value) => {
                                                            const selectedYear = value?.year?.();
                                                            setFieldValue("year", value);
                                                            setFieldValue("month", null);
                                                            setFieldValue("periodId", null);
                                                            setYear(selectedYear);
                                                            setMonth(null);
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="month"
                                                        required
                                                        label={t('unit.month')}
                                                        allowClear
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        picker="month"
                                                        dateFormat="MMMM"
                                                        onChange={(value) => {
                                                            const selectedMonth = value ? String(value.month() + 1).padStart(2, '0') : null;
                                                            setFieldValue("month", value);
                                                            setFieldValue("periodId", null);
                                                            setMonth(selectedMonth);
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="periodId"
                                                        required
                                                        label={t('report.payroll_period')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        options={periodOptions}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                    <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('employee_payroll_report.header')}</span>
                                                    <TableAntd
                                                        columns={columns}
                                                        dataSource={reportEmployeeEarningTable}
                                                        rowKey={(record) => record.id}
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                    />
                                                </Space>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default EmployeePayrollReportComponent;